import { environment } from '../../../environments/environment';
import { Association } from '../models/association.model';
import { ApiService } from './';
import { JwtService } from './jwt.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';

@Injectable()
export class AssociationService {

  constructor(private apiService: ApiService, private jwtService: JwtService,
    private http: HttpClient) { }

  list(): Observable<Association[]> {
    return this.apiService.get('gandadmin/assocs');
  }

  unFilteredList(): Observable<Association[]> {
    return this.apiService.get('gandadmin/assocs_active_by_name');
  }

  listFilter(): Observable<Association[]> {
    return this.apiService.get('gandadmin/assocs_by_active_categories');
  }

  find(params: DataTableParams): Observable<any> {
    return this.apiService.post('gandadmin/assocs/find', params);
  }

  findById(id: number): Observable<Association> {
    return this.apiService.get('gandadmin/assocs/' + id);
  }

  create(association: Association, category: number): Observable<Association> {
    return this.apiService.post('gandadmin/assoc_categories/' + category + '/assocs/new',
      { assoc: association });
  }

  activateOrDeactivate(association: Association): Observable<Association> {
    const verb = association.is_active ? 'deactivate' : 'activate';
    return this.apiService.post('gandadmin/assocs/' + association.id + '/' + verb);
  }

  activateOrDeactivateImpact(association: Association): Observable<Association> {
    const verb = association.is_impact ? 'deactivate' : 'activate';
    return this.apiService.post('gandadmin/assocs/' + association.id + '/impact/' + verb);
  }

  update(association: Association): Observable<Association> {
    return this.apiService.put('gandadmin/assocs/' + association.id, { assoc: association });
  }

  upload(id: number, data: FormData, verb: string) {
    const path = 'gandadmin/assocs/' + id;
    return this.http.put(`${environment.api_url}${path}${verb}`, data, { headers: new HttpHeaders({ Authorization: `Token ${this.jwtService.getToken()}` }) })
      .map(res => res || []);
  }

  downloadCerfa(params: any): Observable<any> {
    return this.apiService.getBlobFile('gandadmin/assocs_cerfa', params);
  }
}
